module.exports = __webpack_public_path__ + "img/img18.f3133067.svg";